import React, {useState, useEffect} from 'react';
import { Accordion, Container, Row, Col, Button, ButtonGroup, ListGroup } from 'react-bootstrap'
import { setAccordionActiveKey, setRecentBets } from "../redux/reducers/storageSlice";
import { getBets } from "../redux/action"
import { useAppSelector, useAppDispatch } from '../hooks'
import Identicon from 'react-identicons';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
// import io from 'socket.io-client';

dayjs.extend(relativeTime)
// const socket = io(process.env.REACT_APP_DATA_SERVER);

const RecentPlays: React.FC = () => {
    
    const [multiplierFilter, setMultiplierFilter] = useState(0)
    const [loading, setLoading] = useState(false)
    const dispatch = useAppDispatch();
    const accordionActiveKey = useAppSelector(state => state.storage.accordionActiveKey);
    const mode = useAppSelector(state => state.storage.mode);
    const selectedToken = useAppSelector(state => state.storage.token);
    const recentBets = useAppSelector(state => state.storage.recentBets);

    const getAndFilterBets = async (show_loader) => {
        if (show_loader) setLoading(true)
        let data = []
        if (multiplierFilter == 0) data = await getBets(false, selectedToken)
        if (multiplierFilter != 0) data = await getBets(multiplierFilter, selectedToken)
        if (show_loader) setLoading(false)
        dispatch(setRecentBets(data))      
    }

    const updateBets = async (newBet) => {
        if (!loading){
            // let filter = multiplierFilter ? multiplierFilter : false
            if((multiplierFilter == newBet.multiplier) || (multiplierFilter == 0)){
                let tempBets = [...recentBets]
                const firstElement = tempBets.shift();
                tempBets.push(newBet)
                dispatch(setRecentBets(tempBets))
            }

        }
    }

    const setMultiplier = (filter) => {
        setMultiplierFilter(filter)
    }

    const setSocket = () => {

    }
    useEffect(() => {
        getAndFilterBets(true)
    }, [multiplierFilter])

    useEffect(() => {
        
        const intervalId = setInterval(() => {
          getAndFilterBets(false)
        }, 2000);
        return () => clearInterval(intervalId);
    }, [multiplierFilter]);


    let buttons = (
            <ButtonGroup  size="sm">
                <Button variant="light" style={{width: '100%'}} onClick={() => setMultiplier(0)} active={multiplierFilter ==0} >
                    <h5 style={{color: "black",marginBottom: 0}}>ALL</h5>
                </Button>                                
                <Button variant="light" style={{width: '100%'}} onClick={() => setMultiplier(process.env.REACT_APP_MULTIPLIER_1)} active={multiplierFilter ==process.env.REACT_APP_MULTIPLIER_1} >
                    <h5 style={{color: "black",marginBottom: 0}}>{process.env.REACT_APP_MULTIPLIER_1}X</h5>
                </Button>
                <Button variant="light" style={{width: '100%'}} onClick={() => setMultiplier(process.env.REACT_APP_MULTIPLIER_2)} active={multiplierFilter ==process.env.REACT_APP_MULTIPLIER_2} >
                    <h5 style={{color: "black",marginBottom: 0}}>{process.env.REACT_APP_MULTIPLIER_2}X</h5>
                </Button>
                <Button variant="light" style={{width: '100%'}} onClick={() => setMultiplier(process.env.REACT_APP_MULTIPLIER_3)} active={multiplierFilter ==process.env.REACT_APP_MULTIPLIER_3} >
                    <h5 style={{color: "black",marginBottom: 0}}>{process.env.REACT_APP_MULTIPLIER_3}X</h5>
                </Button>
                <Button variant="light" style={{width: '100%'}} onClick={() => setMultiplier(process.env.REACT_APP_MULTIPLIER_4)} active={multiplierFilter ==process.env.REACT_APP_MULTIPLIER_4} >
                    <h5 style={{color: "black",marginBottom: 0}}>{process.env.REACT_APP_MULTIPLIER_4}X</h5>
                </Button>
            </ButtonGroup>
        )
    if (mode =="Degen"){
        buttons = (
            <ButtonGroup  size="sm">
                <Button variant="light" style={{width: '100%'}} onClick={() => setMultiplier(0)} active={multiplierFilter ==0} >
                    <h5 style={{marginBottom: 0}}>ALL</h5>
                </Button>                                
                <Button variant="light" style={{width: '100%'}} onClick={() => setMultiplier(process.env.REACT_APP_MULTIPLIER_5)} active={multiplierFilter ==process.env.REACT_APP_MULTIPLIER_5} >
                    <h5 style={{marginBottom: 0}}>{process.env.REACT_APP_MULTIPLIER_5}X</h5>
                </Button>
                <Button variant="light" style={{width: '100%'}} onClick={() => setMultiplier(process.env.REACT_APP_MULTIPLIER_6)} active={multiplierFilter ==process.env.REACT_APP_MULTIPLIER_6} >
                    <h5 style={{marginBottom: 0}}>{process.env.REACT_APP_MULTIPLIER_6}X</h5>
                </Button>                
            </ButtonGroup>
        )
    }
    return (
        <Container style={{paddingLeft: "6%",paddingRight: "6%"}}>
            <div style={{marginTop: 20, marginBottom: 20}}>
            <Accordion defaultActiveKey={['0']} activeKey={accordionActiveKey}>
              <Accordion.Item eventKey="0">
                <Accordion.Header style={{textAlign: 'center' }}><h3 style={{textAlign: "center", width: "100%"}} onClick={() => {
                if (accordionActiveKey =="0") { dispatch(setAccordionActiveKey("1")) } else { dispatch(setAccordionActiveKey("0")) }}}>RECENT PLAYS</h3></Accordion.Header>
                <Accordion.Body>
                    {loading ? 
                        (
                            <img alt="not found" src={"images/loading.gif"} style={{width: "30%"}}/>
                        )
                        :
                        (
                            <div>
                                <Row style={{paddingBottom: 20}}>
                                    {buttons}
                                </Row>                        
                                <Row style={{paddingBottom: 20}}>
                                    <Col style={{padding: 0}}>
                                        <ListGroup>
                                            {
                                                multiplierFilter == 0 ? 
                                                (recentBets.map(({amount, multiplier, wallet, won, createdAt, token}, i) => {
                                                    let product = amount * multiplier
                                                    if (token == "POGR") product = Math.floor(product)
                                                    let msg = ""
                                                    let timeString = dayjs(createdAt).toNow(true) + " ago."
                                                    if (won) {
                                                        msg = <span>({wallet.substring(0, 5)}) <span style={{color: "green", fontWeight: "bold"}}>WON</span> {product} {token} <img src={`https://multiflip.io/images/${token}.png`} height={"20px"} style={{marginRight: 5}}/> on a {multiplier}X Bet</span>
                                                    } else {
                                                        msg = <span>({wallet.substring(0, 5)}) <span style={{color: "red", fontWeight: "bold"}}>LOST</span> {amount} {token} <img src={`https://multiflip.io/images/${token}.png`} height={"20px"} style={{marginRight: 5}}/> on a {multiplier}X Bet </span>
                                                    }
                                                    return <ListGroup.Item key={i+1}><span style={{float: "left"}}><Identicon size={16} style={{float: "left"}} string={wallet}/>{msg}</span><span style={{float: "right"}}>{timeString}</span></ListGroup.Item>
                                                }))
                                                :
                                                (recentBets.map(({amount, multiplier, wallet, won, createdAt, token}, i) => {
                                                    let product = amount * multiplier
                                                    if (token == "POGR") product = Math.floor(product)
                                                    let msg = ""
                                                    let timeString = dayjs(createdAt).toNow(true) + " ago."
                                                    if (won) {
                                                        msg = <span>({wallet.substring(0, 5)}) <span style={{color: "green", fontWeight: "bold"}}>WON</span> {product} {token} <img src={`https://multiflip.io/images/${token}.png`} height={"20px"} style={{marginRight: 5}}/>on a {multiplier}X Bet</span>
                                                    } else {
                                                        msg = <span>({wallet.substring(0, 5)}) <span style={{color: "red", fontWeight: "bold"}}>LOST</span> {amount} {token} <img src={`https://multiflip.io/images/${token}.png`} height={"20px"} style={{marginRight: 5}}/>on a {multiplier}X Bet </span>
                                                    }
                                                    return <ListGroup.Item key={i+1}><Identicon size={20} style={{float: "left"}} string={wallet}/><span style={{float: "left"}}>{msg}</span><span style={{float: "right"}}>{timeString}</span></ListGroup.Item>
                                                }))
                                            }
                                        </ListGroup>
                                    </Col>
                                </Row> 
                            </div>
                        )
                    }
                </Accordion.Body>  
                </Accordion.Item>
            </Accordion>  
            </div>      
        </Container>
    );
};

export default RecentPlays;